<template>
	<v-layout  wrap ma-2>
        <v-flex xs12 mt-3>
            <label ref="label" for="download-excel">
                <vue-six-four
                    ref="vueSixFour"
                    id="download-excel"
                    hidden
                    @vue-six-four="getFile"
                />
                <v-layout>
                    <v-flex xs12 mr-2 class="text-right" >
                        <v-btn
                            color="success"
                            class="btnLoadExcel white--text"
                            @click="downloadRules"
                        >
                            Descargar Plantilla
                        <v-icon right dark>file_download</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12 class="container-import">
                        <BaseInput
                            :height="35"
                            label="Adjuntar excel"
                            v-model="excelName"
                            required
                            class="pr-4"
                        >
                            <span slot="error" class="caption error--text" v-if="!$v.model.base64.required">
                                Es necesario importar un archivo excel
                            </span>
                        </BaseInput>
                        <button class="btn-import" @click="showDialog">
                            <img src="/static/img/actions-list/excel.svg" alt="importar excel">
                        </button>
                    </v-flex>
                </v-layout>
            </label>
		</v-flex>
        <section class="modal-filter-footer">
            <modal-sidebar-button
                success-text="Aceptar"
                @cancel-button-clicked="$emit('close-modal')"
                @accept-button-clicked="sendAccount"
                :is-loading="$v.$invalid || disabledbutton"
            ></modal-sidebar-button>
		</section>
	</v-layout>
</template>

<script>

import { required } from 'vuelidate/lib/validators';
import VueSixFour from 'vue-six-four';

async function created() {
	await this.loadData.call(this);
}

function showDialog() {
	this.$refs.label.click();
}

function customerId() {
	return Number(this.$route.query.customerId);
}

function subsidiaryId() {
	return Number(this.$route.query.subsidiaryId);
}

function validations() {
	const validation = {
		model: {
			base64: {
				required,
			},
		},
	};
	return validation;
}

function getFile(fileInfo) {
	this.excelName = fileInfo.name.replace(/\s/g, '-');
	const base64data = fileInfo.sixFour.split('base64,');
	this.model.base64 = base64data[1];
}

async function sendAccount() {
	const method = 'post';
	const url = 'accounting-definitions-upload';
	const newModel = { ...this.model };
	newModel.subsidiaryId = Number(this.subsidiaryId);
	try {
		this.disabledbutton = true;
		await this.$http[method](url, newModel);
		this.showNotification('Se creó correctamente');
		this.$emit('load-data');
		this.$emit('close-modal');
	} catch (error) {
		this.disabledbutton = false;
		if (error.status === 500) {
			this.showGenericError();
		} else if (error.status === 400) {
			if (error.data.message === 'RULES_REPEAT') {
				this.showGenericError('No se pueden registrar definiciones contables repetidas.');
			} else if (error.data.message === 'FILE_XLSX_ITEM_EMPTY') {
				this.showGenericError('Un item del archivo se encuentra vacío.');
			}
		}
	}
}

async function downloadRules() {
	const body = {
		customerId: this.customerId,
		subsidiaryId: this.subsidiaryId,
	};
	const response = await this.$http.post('dow-accounting-definition-excel', body);
	const byteCharacters = atob(response.data.base64);
	const byteNumbers = [];
	byteCharacters.split('').forEach((char) => {
		byteNumbers.push(char.charCodeAt(0));
	});

	const byteArray = new Uint8Array(byteNumbers);
	const buffer = byteArray.buffer;

	const blob = new Blob([buffer], { type: 'application/octet-stream' });

	const url = URL.createObjectURL(blob);

	const link = document.createElement('a');
	link.href = url;
	link.download = 'reglas_contables.xlsx';

	link.click();

	URL.revokeObjectURL(url);
}

function data() {
	return {
		disabledbutton: false,
		model: {
			base64: {
				required,
			},
		},
		excelName: null,
	};
}

export default {
	name: 'import-accounting-definition',
	created,
	components: {
		VueSixFour,
		BaseInput: () => import('@/components/shared/inputs/base-input'),
	},
	computed: {
		customerId,
		subsidiaryId,
	},
	data,
	methods: {
		downloadRules,
		sendAccount,
		getFile,
		showDialog,
	},
	validations,
};
</script>

<style lang="scss" scoped>
    .text-right {
    text-align: center;
    }
    .container-import {
        position: relative;

        .btn-import {
            background: #03A89E;
            border-radius: 0 5px 5px 0;
            height: 35px;
            padding: 5px 7px 5px 0;
            position: absolute;
            right: 0;
            top: 16px;
            width: 51px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/account-definitions/import-accounting-definitions.vue